import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_OCR } from "../../config/config.json";
import { decryptStorage } from 'utils/utils';

const prepareHeaders = (includeAuthorization = true) => (headers) => {
    headers.set('content-type', 'application/json');
    headers.set('accept', '*/*');
    headers.set('Accept-Encoding', 'gzip, deflate, br');
    headers.set('Connection', 'keep-alive');

    if (includeAuthorization) {
        const token = decryptStorage(localStorage.getItem("token"));
        if (token) headers.set('Authorization', `Bearer ${token}`);
    }

    return headers;
};

const baseQuery = fetchBaseQuery({
    baseUrl: API_OCR,
    extraOptions: { timeout: 30000 },
    prepareHeaders: prepareHeaders(true), // Por defecto, se incluye la autorización
});

export const microServiceOcrAPI = createApi({
    reducerPath: 'microServiceOcrAPI',
    baseQuery,
    endpoints: () => ({})
});